export enum PoiTypesEnum {
  TIME_LIMIT = "time-limit",
}
